import React from "react";
import './index.css'
import { secureUrl } from "../../../../utils/sortArray/secureUrl";
import FifaCard from "../../../PlantillaScreen/components/PlantillaGrid/components/FifaCard";

const SoccerField = ({teams})=>{
   const currentLineUp = teams?.selectedTeam === 'local' ? teams?.local : teams?.visitor
   const currentTeamInfo = teams?.selectedTeam === 'local' ? teams?.matchInfo?.equipoLocal
    : teams?.matchInfo?.equipoVisitante

    return(<div className="soccer-field-container">
         <img className="soccer-field-container-img"    src="https://assets.talachaapp.com/Gemini_Generated_Image_m0bl7rm0bl7rm0bl.png"/>
        <div className="soccer-field-players-container">
                    {
            currentLineUp?.map((linePosition, index)=>{
                
                return(
               <div className="postion-players-field-container">
                <div className="postion-players-field">{
                    linePosition?.map((player,i)=>{
                    console.log('player', player)
                    return(
                    
                <FifaCard isLineUp={true} player={player?.jugador} />)
                })

                    }</div>

               </div>
) 
            })
        }

        </div>

    </div>
    )
}

export default SoccerField